import { FC } from "react";

import "./CountBadge.scss";

interface ICountBadgeProps {
  count: number;
  className?: string;
}

const CountBadge: FC<ICountBadgeProps> = ({
  count,
  className = "count-badge",
}) => {
  if (count <= 0) return null;
  
  return (
    <div className={ className }>
      { count }
    </div>
  );
};

export default CountBadge;
